var cilArrowThickToRight = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M176,56V176H16V336H176V456h38.623l200-199.8L214.635,56Zm32,361.384V304H48V208H208V94.639L369.373,256.174Z' class='ci-primary'/><rect width='32' height='400' x='463.998' y='56' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilArrowThickToRight };

